<template>
    <Teleport :to="headerMenuElement">
        <DButton
            theme="transparent-subtle"
            data-cy="tour-skip"
            @click="goToNextStep(false)"
        >
            Skip
        </DButton>
    </Teleport>
    <div
        class="flex flex-col grow min-h-full"
        data-cy="tour-component"
    >
        <component
            :is="layoutComponentType"
            v-if="props.config"
            ref="layoutComponent"
            :config="props.config"
            :data-cy="`tour-layout-${tourStore.currentLayoutType}`"
            @action-completed="goToNextStep"
            @action-skipped="goToNextStep"
        />
    </div>
</template>
<script setup>
    import { useRouter } from 'vue-router'
    import { DButton } from '@digistorm/spark'

    import { useTourStore } from '@/stores/tour'
    import { useModuleHelpers } from '@/composables'
    import * as layouts from '@/components/ui/TourLayouts'

    const props = defineProps({
        config: Object,
        class: String,
        dataCy: String,
    })

    const router = useRouter()
    const moduleStore = useModuleStore()
    const tourStore = useTourStore()
    const moduleHelpers = useModuleHelpers()

    const headerMenu = inject('headerMenu', null)
    const layoutComponent = ref(null)

    const headerMenuElement = computed(() => {
        return headerMenu?.value?.$el?.querySelector('#header-menu')
    })

    const layoutComponentType = computed(() => {
        return layouts[props.config.layout.type]
    })

    const goToNextStep = async (replace = false) => {
        const nextStepModule = await tourStore.getNextStepModule()

        if (!nextStepModule) {
            tourStore.completeTour()
            moduleHelpers.navigateBackToRoot(router)
            return
        }

        if (replace) {
            moduleStore.replaceLastModule(nextStepModule)
            router.replace({ name: 'view', params: { id: nextStepModule.id } })
            return
        }
        moduleStore.addModule(nextStepModule)
        router.push({ name: 'view', params: { id: nextStepModule.id } })
    }
</script>
